var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.625 4.792a.625.625 0 1 0-1.25 0v4.583H4.792a.625.625 0 1 0 0 1.25h4.583v4.583a.625.625 0 0 0 1.25 0v-4.583h4.583a.625.625 0 1 0 0-1.25h-4.583z"
  })));
};
export default SvgPlus;